import type { ConsentForm, Log, Resident } from '@lmc/ts-common'
import type * as React from 'react'
import type { CSSProperties } from 'react'
import { SignatureSection } from '../../../../../../components/generic'

type LogsSectionProps = {
  consentForm: ConsentForm
  isSubmitting: boolean
  logs: Log[]
  onSubmitSign?: ({ formState, onSuccess }: any) => Promise<void>
  resident: Resident
  translate: (id: string, variable?: any) => string
}

export const LogsSection = ({
  consentForm,
  isSubmitting,
  logs,
  onSubmitSign,
  resident,
  translate
}: LogsSectionProps): React.ReactElement => (
  <div style={styles.signaturesSection as CSSProperties}>
    <SignatureSection
      customSignButton
      title={translate('consentHistory')}
      resident={resident}
      logs={logs}
      // @ts-ignore
      buttonLabel={onSubmitSign && translate('sign')}
      // @ts-ignore
      footerLabel={consentForm?.title}
      confirmText={translate('confirm', {
        variable: resident?.preferredName || resident?.name?.first
      })}
      isSubmitting={isSubmitting}
      helpUrl="https://support.logmycare.co.uk/en/articles/6014548-how-do-i-add-and-sign-consent-and-lack-of-capacity-forms"
      onSubmit={onSubmitSign as any}
    />
  </div>
)

const styles = {
  signaturesSection: {
    marginTop: 50 as const
  }
}

export default LogsSection
